import { fetchJsonWithAuthJWTToken } from "ra-data-django-rest-framework"

import endpoints from "api/endpoints"

class LessonsAPI {
  async mailoutEmails(id) {
    const { json } = await fetchJsonWithAuthJWTToken(
      endpoints.lessonMailoutEmails(id)
    )
    return json
  }

  async sendMailout(id, data) {
    const { json } = await fetchJsonWithAuthJWTToken(
      endpoints.sendLessonMailout(id),
      {
        method: "post",
        body: JSON.stringify(data),
      }
    )
    return json
  }
}

export default new LessonsAPI()
